<template>
  <div class="mr-4 ml-4" style="width: 90vw;">
    <div class="row w-100 text-primary mb-4" style="font-size: 1rem;">
      <b class="mr-1">Instrucciones: </b> {{instructions}}
    </div>

    <div class="row w-100">
      <alert
        type="success"
        dismissible
        @dismiss="successMessage = ''"
        :isVisible="successMessage ? true : false"
      >
        {{successMessage}}
      </alert>
    </div>

    <div class="row w-100">
      <alert
        type="danger"
        dismissible
        @dismiss="errorMessage = ''"
        :isVisible="errorMessage ? true : false"
      >
        {{errorMessage}}
      </alert>
    </div>

    <div class="row text-center w-100">
      <table class="w-100 mb-4" v-if="isEvaluated && showAnswers && incorrectAnswers.length > 0">
        <thead>
          <tr>
            <td class="bg-primary" colspan="3">
                Respuestas correctas
            </td>
          </tr>
          <tr>
            <td class="bg-primary text-center">
                Palabra
            </td>
            <td class="bg-primary text-center">
                Tu respuesta
            </td>
            <td class="bg-primary text-center">
                Respuestas correctas
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(answer, index) in incorrectAnswers" :key="answer.keyWord + '-' + index">
            <td
              class="bg-white text-primary text-center"
              style="width: 33%;"
            >
              {{answer.word}}
            </td>
            <td
              class="bg-white text-danger text-center"
              style="width: 33%;"
            >
              {{answer.newWord}}
            </td>
            <td
              class="bg-white text-success text-center"
              style="width: 33%;"
            >
              {{answer.answers}}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="card pb-2 text-primary">
        <div class="card-body">
          <div class="row">
            <div class="col-lg pt-2 text-justify" style="font-size: 1.5rem;">
              <span 
                v-for="(word, index) in wordsToRender" :key="`${word.word}-${index}`"
              >
                <template v-if="word.isQuestion">
                  <template v-if="!isEvaluated && !showResults">
                    <button @click="selectWord(word)" v-if="!word.newWord" type="button" class="btn btn-outline-primary">
                      {{`${word.word}`}}
                    </button>
                    <button @click="selectWord(word)" v-if="word.newWord" type="button" class="btn btn-primary">
                      {{`${word.newWord}`}}
                    </button>
                  </template>             

                  <template v-if="isEvaluated || (!isEvaluated && showResults)">
                    <button @click="selectWord(word)" v-if="!isEvaluated && !word.newWord" type="button" class="btn btn-outline-primary">
                      {{`${word.word}`}}
                    </button>
                    <button @click="selectWord(word)" v-if="word.newWord && word.isSelecting" type="button" class="btn btn-outline-primary">
                      {{`${word.newWord}`}}
                    </button>
                    <button @click="selectWord(word)" :disabled="isEvaluated" v-if="word.newWord && !word.isCorrect && !word.isSelecting" type="button" class="btn btn-danger">
                      {{`${word.newWord}`}}
                    </button>
                    <button @click="selectWord(word)" :disabled="isEvaluated" v-if="isEvaluated && !word.newWord && !word.isCorrect && !word.isSelecting" type="button" class="btn btn-danger">
                      {{`${word.word}`}}
                    </button>
                    <button  @click="selectWord(word)" :disabled="isEvaluated" v-if="word.newWord && word.isCorrect && !word.isSelecting" type="button" class="btn btn-success">
                      {{`${word.newWord}`}}
                    </button>
                  </template>

                </template>
                <template v-else>
                  {{`${word.word }`}}
                </template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row w-100">
      <div class="col-lg text-center">
        <button class="btn btn-primary w-50" @click="evaluate()" v-if="!isEvaluated">
          Evaluar
        </button>
        <button class="btn btn-primary w-50" @click="restart()" v-else>
          <i class="fas fa-undo"></i>
          Reiniciar
        </button>
      </div>
    </div>

    <div>
      <modal @close="cancelAnswer()" :show.sync="modals.classic" headerClasses="justify-content-center text-primary" :showClose="false" modalClasses="text-primary">
        <template v-if="currentKeyWord && currentKeyWord.options">
          <div slot="header">
            <div class="text-right">
              <i class="fas fa-times ml-4 text-right cursor-pointer" @click="cancelAnswer()"></i>
            </div>
            <h4 slot="header" class="title title-up text-primary pt-0">
              Elige un sinónimo para <span class="text-secondary">{{currentKeyWord.word}}</span>
            </h4>
          </div>
          <div v-for="(option, index) in currentKeyWord.options" :key="`${option.word}-${index}`">
            {{option.newWord}}
            <n-radio v-model="currentKeyWord.newWord" :label="option.word">{{option.word}}</n-radio>
          </div>
        </template>
        <template slot="footer">
          <n-button v-if="currentKeyWord" type="danger" :class="!currentKeyWord.newWord ? 'cursor-disabled' : ''" @click.native="eraseAnswer()" :disabled="!currentKeyWord.newWord">
            Borrar respuesta
          </n-button>
          <n-button type="primary" @click.native="answer(currentKeyWord)">Seleccionar respuesta</n-button>
        </template>
      </modal>
    </div>

  </div>
</template>

<script>
export default {
  name: 'synonyms',
  interval: null,
  startInterval: null,
  props: {
    instructions: {
      type: String,
      default: 'Da clic en las palabras encerradas y elige el sinónimo correcto, cuando hayas elegido el sinónimo para todas las palabras da clic en "Evaluar".'
    },
    text: {
      type: String,
      required: true
    },
    synonyms: {
      type: Array,
      required: true
    },
    synonyms: {
      type: Array,
      required: true
    },
    showResults: {
      type: Boolean,
      default: false
    },
    showAnswers: {
      type: Boolean,
      default: false
    },
    maxAttempts: {
      type: Number,
      default: 0
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      successMessage: '',
      errorMessage: '',
      isEvaluated: false,
      currentKeyWord: null,
      wordsToRender: null,
      remainingAttempts: this.maxAttempts,
      modals: {
        classic: false
      }
    }
  },
  computed: {
    allWords() {
      return this.text.split(' ');
    },
    allWordsLength() {
      return this.allWords.length;
    },
    incorrectAnswers() {
      let questions = this.wordsToRender.filter(word => word.isQuestion);

      return questions.filter(word => !word.isCorrect).map(word => {
        word.answers = word.options.filter(option => option.isSynonymous).map(option => option.word);
        console.log(word.answers);
        word.answers = word.answers.join(', ');
        return word;
      });
    }
  },
  methods: {
    init() {
      this.wordsToRender = this.allWords.map((word, index) => {
        let wordObject = {
          word,
          index,
          isQuestion: false
        }
        let synonymousObject = this.synonyms.find(synonymous => word == synonymous.keyWord);
        if (synonymousObject) {
          wordObject.options = synonymousObject.options;
          wordObject.newWord = '';
          wordObject.isCorrect = false;
          wordObject.isQuestion = true;
        }
        return wordObject;
      });
    },
    selectWord(word) {
      if (this.isEvaluated) return;
      this.successMessage = '';
      this.errorMessage = '';
      word.lastWord = word.newWord;
      this.currentKeyWord = word;
      this.currentKeyWord.isSelecting = true;
      this.modals.classic = true;
    },
    answer() {
      if (!this.currentKeyWord.newWord) return;
      this.currentKeyWord.isSelecting = false;
      let synonymousSelected = this.currentKeyWord.options.find(option => option.word == this.currentKeyWord.newWord);
      this.currentKeyWord.isCorrect = synonymousSelected.isSynonymous;
      if (this.maxAttempts > 0 && !this.currentKeyWord.isCorrect) {
        this.remainingAttempts = this.remainingAttempts - 1;
        if (this.remainingAttempts == 0) {
          let questions = this.wordsToRender.filter(word => word.isQuestion);

          let correctAnswers = questions.filter(word => word.isCorrect);

          this.errorMessage = `Se acabarón tus intentos, respondiste ${correctAnswers.length} correctas de ${questions.length}`;

          this.isEvaluated = true;
        } else this.errorMessage = 'Respuesta incorrecta, te quedan ' + this.remainingAttempts + ' intentos';
      }
      this.modals.classic = false;
    },
    eraseAnswer() {
      this.currentKeyWord.isCorrect = false;
      this.currentKeyWord.newWord = '';
      this.currentKeyWord.isSelecting = false;
      this.modals.classic = false;
    },
    cancelAnswer() {
      this.currentKeyWord.newWord = this.currentKeyWord.lastWord;
      this.currentKeyWord.isSelecting = false;
      this.modals.classic = false;
    },
    restart() {
      this.successMessage = '';
      this.errorMessage = '';
      this.isEvaluated = false;
      this.currentKeyWord = null;
      this.wordsToRender = null;
      this.remainingAttempts = this.maxAttempts;
      this.init();
    },
    evaluate() {
      this.successMessage = '';
      this.errorMessage = '';

      let isInvalid = this.wordsToRender.some(word => (word.isQuestion && !word.newWord));

      if (isInvalid) {
        this.errorMessage = '¡Ups!, aún no terminas, elige un sinómimo para cada palabra.';
        return;
      }

      let questions = this.wordsToRender.filter(word => word.isQuestion);

      let correctAnswers = questions.filter(word => word.isCorrect);

      this.successMessage = `¡Has terminado!, respondiste ${correctAnswers.length} correctas de ${questions.length}`;

      this.isEvaluated = true;
    }
  }
}
</script>

<style scoped>
.btn-success {
  background-color: rgba(24, 206, 15, 0.8);
}

.btn-outline-primary {
  border: 1px solid #023F85 !important;
  background-color: white;
  color: #023F85;
}

.btn-outline-primary:hover {
  border: 1px solid #023F85 !important;
  background-color: #023F85;
  color: white;
}

.cursor-disabled {
  cursor: not-allowed;
}
</style>
